import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { useCartStore } from '@/stores/cart-store/cartStore'
import { Step, useStepStore } from '@/stores/step-store/stepStore'

import { deleteReservation } from '../api/deleteReservation'

export const useCancelReservation = () => {
	const currentStep = useStepStore.use.currentStep()
	const lastStep = useRef<Step>(currentStep)
	const { id } = useCartStore.use.reservation()
	const location = useCartStore.use.location()

	const { mutate } = useMutation({
		mutationFn: (reservationId: string) =>
			deleteReservation({
				reservationId,
				hotelCode: location!.hotelCode!,
			}),
	})

	useEffect(() => {
		if (lastStep.current === 'GUEST_DATA' && currentStep !== 'GUEST_DATA' && id) {
			mutate(id)
		}
		lastStep.current = currentStep
	}, [currentStep, id, mutate])
}
